import { apiFetch } from '@/lib/api';

export interface EventDTO {
  id: string;
  client_id: string;
  name: string;
  slug: string;
  description?: string | null;
  event_notes?: string | null;
  // Venue filters stored as JSONB
  venue_filters?: Record<string, any> | null;
  // Event details
  start_date?: string | null;
  end_date?: string | null;
  expected_attendees?: number | null;
  budget_min?: number | null;
  budget_max?: number | null;
  objective?: string | null;
  base_currency?: string | null;
  temperature_unit?: 'celsius' | 'fahrenheit' | null;
  distance_unit?: 'kilometers' | 'miles' | null;
  // Flexible date fields
  date_type?: 'date_range' | 'month' | null;
  event_month?: string | null;
  date_display_override?: string | null;
  days_of_stay?: number | null;
  // Cvent RFP Integration
  cvent_rfp_id?: string | null;
  cvent_rfp_name?: string | null;
  cvent_rfp_code?: string | null;
  cvent_connected_at?: string | null;
  cvent_connected_by_user_id?: string | null;
  cvent_data_last_synced_at?: string | null;
}

export interface EventWithClientDTO extends EventDTO {
  client_name: string;
}

export class EventsService {
  async listAll(): Promise<EventWithClientDTO[]> {
    const res = await apiFetch('/api/events');
    if (!res.ok) throw new Error('Failed to fetch events');
    const data = await res.json();
    return data.data as EventWithClientDTO[];
  }

  async listByClient(clientId: string): Promise<EventDTO[]> {
    const res = await apiFetch(`/api/clients/${clientId}/events`);
    if (!res.ok) throw new Error('Failed to fetch events');
    const data = await res.json();
    return data.data as EventDTO[];
  }

  async get(id: string): Promise<EventDTO> {
    const res = await apiFetch(`/api/events/${id}`);
    if (!res.ok) throw new Error('Failed to fetch event');
    const data = await res.json();
    return data.data as EventDTO;
  }

  async create(clientId: string, input: { name: string; description?: string; venue_filters?: Record<string, any> | null }): Promise<{ id: string }> {
    const res = await apiFetch(`/api/clients/${clientId}/events`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(input),
    });
    if (!res.ok) throw new Error('Failed to create event');
    const data = await res.json();
    return data.data as { id: string };
  }

  async update(id: string, updates: Partial<EventDTO>): Promise<void> {
    const res = await apiFetch(`/api/events/${id}`, {
      method: 'PATCH',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(updates),
    });
    if (!res.ok) throw new Error('Failed to update event');
  }

  async delete(id: string): Promise<void> {
    const res = await apiFetch(`/api/events/${id}`, { method: 'DELETE' });
    if (!res.ok) throw new Error('Failed to delete event');
  }
}


